export default {
    // Aqua variant
    aqua: {
      // Container
      root: "space-y-6",
      container: "space-y-6",
      section: "",
  
      // Grid system
      grid: "grid gap-4",
      grid_cell: "bg-paper rounded-[24px] shadow-md p-6",
  
      // Grid column utilities
      grid_cols_1: "grid-cols-1",
      grid_cols_2: "grid-cols-1 md:grid-cols-2",
      grid_cols_3: "grid-cols-1 md:grid-cols-3",
      grid_cols_4: "grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
      col_span_1: "col-span-1",
      col_span_2: "col-span-1 md:col-span-2",
      col_span_3: "col-span-1 md:col-span-3",
      col_span_4: "col-span-1 md:col-span-4",
  
      // Dark header styles
      dark_header_wrapper: "bg-paper rounded-xl overflow-hidden shadow-sm",
      dark_header: "bg-text p-6 md:p-8",
      dark_header_grid: "grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8",
      dark_header_section: "",
      dark_header_divider:
        "border-b md:border-b-0 md:border-r border-neutral_3 pb-6 md:pb-0 md:pr-8",
      dark_header_children: "p-6 bg-canvas",
      dark_header_label: "text-neutral_2",
      dark_header_value: "text-white",
  
      // Stat cell styles
      stat_label: "text-text_secondary text-sm",
      stat_value_wrapper: "flex items-baseline mt-2",
      stat_value: "font-light text-text text-2xl",
      stat_suffix: "ml-3 font-normal text-text_secondary",
  
      // Medium stat cell styles
      stat_medium_label:
        "uppercase tracking-wider mb-2 text-text_secondary text-xs",
      stat_medium_value_wrapper: "flex items-baseline",
      stat_medium_value: "font-bold text-text text-xl",
      stat_medium_suffix: "ml-2 text-text_secondary",
  
      // Text cell styles
      text_label: "uppercase tracking-wider mb-2 text-text_secondary text-xs",
      text_value: "font-semibold text-text",
  
      // Code cell styles
      code_label: "uppercase tracking-wider mb-2 text-text_secondary text-xs",
      code_value: "text-text font-mono font-medium break-allmb-0",
  
      // Custom cell styles
      custom_text: "text-text",
  
      // Badge cell styles
      badge_container: "bg-neutral_3 border border-neutral_2 rounded-lg p-4",
      badge_label: "text-neutral_1 text-xs mb-1",
      badge_value: "text-primary font-mono font-medium text-base",
      badge_tag:
        "mt-2 bg-neutral_2/50 text-neutral_1 px-2 py-1 rounded text-xs font-medium inline-block",
  
      // Highlight cell styles
      highlight_default: {
        container: "bg-success/10 border border-success/20 rounded-lg p-4",
        content: "flex items-center space-x-3",
        icon_wrapper:
          "w-10 h-10 bg-success/20 rounded-full flex items-center justify-center",
        title: "text-success font-medium",
        subtitle: "text-text_secondary",
      },
  
      // Dynamic highlight styles function
      getHighlightStyles: (color) => {
        const colorMap = {
          success: {
            container: "bg-success/10 border border-success/20 rounded-lg p-4",
            content: "flex items-center space-x-3",
            icon_wrapper:
              "w-10 h-10 bg-success/20 rounded-full flex items-center justify-center",
            title: "text-success font-medium",
            subtitle: "text-text_secondary",
          },
          error: {
            container: "bg-error/10 border border-error/20 rounded-lg p-4",
            content: "flex items-center space-x-3",
            icon_wrapper:
              "w-10 h-10 bg-error/20 rounded-full flex items-center justify-center",
            title: "text-error font-medium",
            subtitle: "text-text_secondary",
          },
          warning: {
            container: "bg-warning/10 border border-warning/20 rounded-lg p-4",
            content: "flex items-center space-x-3",
            icon_wrapper:
              "w-10 h-10 bg-warning/20 rounded-full flex items-center justify-center",
            title: "text-warning font-medium",
            subtitle: "text-text_secondary",
          },
          info: {
            container: "bg-info/10 border border-info/20 rounded-lg p-4",
            content: "flex items-center space-x-3",
            icon_wrapper:
              "w-10 h-10 bg-info/20 rounded-full flex items-center justify-center",
            title: "text-info font-medium",
            subtitle: "text-text_secondary",
          },
          primary: {
            container: "bg-primary/10 border border-primary/20 rounded-lg p-4",
            content: "flex items-center space-x-3",
            icon_wrapper:
              "w-10 h-10 bg-primary/20 rounded-full flex items-center justify-center",
            title: "text-primary font-medium",
            subtitle: "text-text_secondary",
          },
        }
  
        return colorMap[color] || colorMap.success
      },
  
      // Cell style getters
      getCellStyle: (className) => className || "",
      getGridStyle: (cols) => `grid-cols-${cols}`,
    },
  }
  